import { render, staticRenderFns } from "./UserAttachments.vue?vue&type=template&id=c5484b4e"
import script from "./UserAttachments.vue?vue&type=script&lang=js"
export * from "./UserAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports